import moment from "moment";
import PropTypes from "prop-types";
import React, { useState } from "react";

import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Grid from "@material-ui/core/Grid";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Typography from "../../../../components/Helpers/Typography";
import { commandHistoryDetailFields } from "../../../../constants";


const useStyles = makeStyles((theme) => ({
  container: {
    margin: "0",
    width: "100%",
    paddingRight: 0,
    paddingTop: 12,
    paddingBottom: 12,
  },
  Accordion: {
    boxShadow: "none",
    borderBottomWidth: "1px",
    borderBottomStyle: "solid",
    borderBottomColor: theme.palette.primary.divider,
    backgroundColor: theme.palette.primary.dark,
    paddingLeft: 0,
  },
  basicSpacing: {
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 0,
    paddingRight: 0,
  },
}));

export const CommandListItem = (props) => {
  const { command } = props;
  const theme = useTheme();
  const classes = useStyles(theme);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Accordion className={classes.Accordion} onChange={(e, expanded) => setIsOpen(expanded)}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Grid container spacing={1} className={classes.container}>
          <Grid item xs={0} md={1} />
          <Grid
            item
            xs={5}
            md={3}
            className={classes.basicSpacing}
          >
            <Typography style={{ fontSize: 14 }}>{command.rpc_name}</Typography>
          </Grid>

          <Grid item xs={2} className={classes.basicSpacing}>
            <Typography style={{ fontSize: 14 }}>{command.status}</Typography>
          </Grid>

          <Grid item xs={4} style={{ display: "flex", alignItems: "center" }}>
            <Typography style={{ fontSize: 12 }}>
              {moment(command.created).format("MMMM DD, YYYY HH:mm:ss")}
            </Typography>
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails style={{ padding: 0 }}>
        {isOpen && (
          <Grid container style={{ paddingBottom: 20 }}>
            <Grid item xs={1} md={1} />
            <Grid item xs={11}>
              <Grid item xs={11} className={classes.basicSpacing} style={{ paddingLeft: 14 }}>
                <Typography style={{ fontSize: 14 }}>Details:</Typography>
              </Grid>
              {commandHistoryDetailFields.map((name) => {
                const value =
                  typeof command[name] === "object" ? (
                    <Typography style={{ fontSize: 12 }} component="pre">
                      {JSON.stringify(command[name], null, 2)}
                    </Typography>
                  ) : (
                    <Typography style={{ fontSize: 12 }}>{command[name]}</Typography>
                  );
                return (
                  <Grid key={name} container>
                    <Grid item xs={3} className={classes.basicSpacing} style={{ paddingLeft: 14 }}>
                      <Typography style={{ fontSize: 12 }} color="lightgray">
                        {name}
                      </Typography>
                    </Grid>

                    <Grid item xs={8} className={classes.detailField} style={{ fontSize: 10 }}>
                      {value}
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

CommandListItem.propTypes = {
  command: PropTypes.object.isRequired,
};

export default CommandListItem;
